







import { defineComponent } from "@vue/composition-api";
import providers from "@/lib/providers";
import { PersonalInformation } from "@teacherskaya/api-provider/dist/api/PersonalInformationProvider";
import { User } from "@teacherskaya/api-provider/dist/api/UserProvider";
import { FormFields, FormValue, FormValues } from "@/types";
import BlockBase from "@/components/BlockBase.vue";
import BlockBaseForm from "@/components/BlockBaseForm.vue";
import BlockBaseViewText from "@/components/BlockBaseViewText.vue";
import { fields } from "./config";

export default defineComponent({
  name: "BlockPersonalInformation",
  components: { BlockBaseViewText, BlockBaseForm, BlockBase },
  props: {
    user: { type: Object as () => User, required: true },
  },
  data() {
    return {
      title: "Personal Information",
      editing: false,
      showStateField: false,
      personalInformation: null as PersonalInformation | null,
    };
  },
  computed: {
    fields(): FormFields {
      return fields
        .map(item => {
          item.value = (this.personalInformation ?? {})[item.name as keyof PersonalInformation];
          return item;
        })
        .filter(item => {
          if (item.name !== "state") return true;
          return this.showStateField;
        });
    },
    userId(): string {
      return this.user.id;
    },
    rows(): FormValue {
      const info = this.personalInformation;
      return [
        { fields: [info?.firstName, info?.lastName], separator: " " },
        { fields: [info?.city, info?.country, info?.state, info?.zip] },
        { fields: [info?.address], append: "<br/><br/>" },
        { fields: [info?.phone] },
      ];
    },
  },
  methods: {
    async getData() {
      this.personalInformation = await providers.PersonalInformationProvider.find({ id: this.user.id });
    },
    showEdit() {
      this.editing = true;
      this.inputHandler(this.personalInformation);
    },
    inputHandler(values: PersonalInformation | null) {
      this.showStateField = ["US", "CA"].indexOf(values?.country ?? "") > -1;
    },
    async save(personalInformationToSave: FormValues) {
      try {
        this.personalInformation = await providers.PersonalInformationProvider.update({
          data: { userId: this.userId, ...personalInformationToSave },
        });
      } finally {
        this.editing = false;
      }
    },
  },
  async created() {
    await this.getData();
  },
});
